"use client";

import { Text } from "@hubble/web";
import { cn } from "app/_components/components/utils";

export function CardDisplay({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <Text.Display
      className={cn(
        "small-desktop:max-w-1/2 max-small-desktop:text-[44px]! max-small-desktop:leading-11!",
        className
      )}
      color="white"
      marketing
      size="sm"
    >
      {children}
    </Text.Display>
  );
}

export function CardHeading({
  children,
  className,
  size = "sm"
}: {
  children: React.ReactNode;
  className?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}) {
  return (
    <Text.Heading
      className={cn(
        "small-desktop:max-w-1/2 small-desktop:text-4xl! max-w-full text-[28px]!",
        className
      )}
      color="white"
      size={size}
    >
      {children}
    </Text.Heading>
  );
}

export function CardBody({
  children,
  className,
  color,
  fontSize,
  size = "md"
}: {
  children: React.ReactNode;
  className?: string;
  color?: string;
  fontSize?: string;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}) {
  return (
    <Text.Body
      className={cn("small-desktop:max-w-1/2", className)}
      color={color}
      fontSize={fontSize}
      size={size}
    >
      {children}
    </Text.Body>
  );
}
